import type { HttpProvider } from './constants'
import { APP_FULL_NAME } from './constants'

import { AxiosProvider, ApiError } from '../providers/axios'
import { whenRequestWithError, whenResponseWithError } from '../providers/axios'
import type { Instance, RequestConfig, RequestHeaders, ResponseError } from '../providers/axios'

class HttpManager {
  private httpProvider: HttpProvider

  constructor() {
    this.httpProvider = AxiosProvider
  }

  public create(config: RequestConfig): Instance {
    return this.httpProvider.create({
      ...config,
      headers: {
        ...config.headers,
        'X-App-Name': APP_FULL_NAME
      }
    })
  }
}

export type { RequestConfig, RequestHeaders, ResponseError }

export { HttpManager, ApiError, whenRequestWithError, whenResponseWithError }
